import { render, staticRenderFns } from "./EditorCardComponent.vue?vue&type=template&id=86b3cb78&scoped=true&"
import script from "./EditorCardComponent.vue?vue&type=script&lang=js&"
export * from "./EditorCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditorCardComponent.vue?vue&type=style&index=0&id=86b3cb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b3cb78",
  null
  
)

export default component.exports